import React, { useEffect, useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { auth } from "./firebase"; 

function MenuBar() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <Navbar
      bg="light"
      expand="lg"
      style={{ paddingLeft: "20px", paddingRight: "20px" }}
    >
      <Navbar.Brand href="#home">PulseSync</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <LinkContainer to="/">
            <Nav.Link>Home</Nav.Link>
          </LinkContainer>
          {user && (
            <>
              <LinkContainer to="/subscription">
                <Nav.Link>Subscription</Nav.Link>
              </LinkContainer>
            </>
          )}
        </Nav>
        <Nav className="ms-auto">
          {user ? (
            <>
              <Nav.Link href="#logout" onClick={() => auth.signOut()}>
                Logout
              </Nav.Link>
            </>
          ) : (
            <>
              <LinkContainer to="/login">
                <Nav.Link>Login</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/signup">
                <Nav.Link>Sign Up</Nav.Link>
              </LinkContainer>
            </>
          )}
          <LinkContainer to="/terms">
            <Nav.Link className="text-muted small">Terms</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/privacy">
            <Nav.Link className="text-muted small">Privacy</Nav.Link>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default MenuBar;
